<template>
  <div id="folders__container">
    <no-content
      :show="!folders?.length && !isLoading"
      text="No folders exist"
    />
    <template v-if="!isLoading">
      <drop-list
        :items="foldersToRender"
        :column="true"
        @reorder="onReorder"
      >
        <template #item="{item: folder}">
          <drag
            :id="`${folder.folderGuid}_folder-header`"
            :key="folder.label"
            :model="folder"
            :data="folder"
            :drag-image-opacity="0.2"
            :disabled="!isDragModeEnabled"
          >
            <generic
              :is-d-n-d-activated="true"
              :model="folder"
              entity-type="table"
            >
              <no-content
                v-if="!isDragModeEnabled"
                :show="!folder.children.length"
                text="There are no tables in this folder"
              />
            </generic>
          </drag>
        </template>
      </drop-list>
    </template>
  </div>
</template>

<script>
import FolderHeader from '@/modules/DataManagement/views/module/components/FolderHeader.vue';
import {createNamespacedHelpers} from 'vuex';
import TableCard from '@/modules/DataManagement/components/TableCard.vue';
import NewTableItem from '@/modules/DataManagement/views/module/components/NewTableItem.vue';
import NoContent from '@/core/components/NoContent.vue';
import ContentSpinner from '@/core/components/ContentSpinner.vue';
import Generic from '@/core/components/Generic.vue';
import {Drag, DropList} from 'vue-easy-dnd';

const {
  mapState:sidebarMapState,
  mapActions:sidebarMapActions,
} = createNamespacedHelpers('sidebar');
export default {
  name: 'FoldersList',
  components: {
    ContentSpinner,
    NoContent,
    NewTableItem,
    FolderHeader,
    TableCard,
    Generic,
    Drag,
    DropList,
  },
  data() {
    return {
      moduleUuid: null,
    };
  },
  computed: {
    ...sidebarMapState({
      isDragModeEnabled: state => state.isDragModeEnabled,
      folders: state => state.moduleInfo,
      isLoading: state => state.isLoading,
      foldersListWithExceptions: state => state.foldersListWithExceptions,
    }),
    foldersToRender() {
      return this.folders && this.folders
        .filter(el => (
          !['none', 'deny'].includes(el.currentUserPermissionLevel)
          || (el.folderGuid in this.foldersListWithExceptions)
        ));
    },
  },
  methods: {
    ...sidebarMapActions([
      'getModuleDetails',
      'updateFolderSortOrder',
    ]),
    async onReorder(e) {
      e.apply(this.folders);
      const isSuccess = await this.updateFolderSortOrder();
      this.$toasted[isSuccess ? 'success' : 'error'](
        isSuccess
          ? 'Items reordered successfully'
          : 'Something went wrong'
        , {duration: TOASTER_DURATION},
      );
    },
  },
  async beforeMount() {
    this.moduleUuid = this.$route.params.moduleUuid || this.$route.query.module_uuid;
    this.moduleUuid && await this.getModuleDetails(this.moduleUuid);
  },

};
</script>

<style scoped lang="scss">
.folder-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1rem;

  &.empty {
    display: flex;
    justify-content: center;
  }
}
</style>